// extracted by mini-css-extract-plugin
export default {"title":"P--z","warning":"Q--z","sizeOptionsLegendText":"R--z"};